import { ChevronRight } from '../../Assets/Icons'
import { Button, SVG } from '../../Atoms'
import { LeksikonCategoryProps } from './props'
import { CategoryHeader, StyledLeksikonCategory } from './styles'
import { Grid } from '../../Molecules'
import { ReactElement } from 'react'

export const LeksikonCategory = ({
    title,
    buttons,
}: LeksikonCategoryProps): ReactElement => {
    return (
        <StyledLeksikonCategory>
            <CategoryHeader>{title}</CategoryHeader>
            <Grid>
                {buttons.map(({ onClick, text }, key) => (
                    <Button
                        css={{
                            fontWeight: 400,
                            gap: '$2',
                            justifyContent: 'space-between',
                            px: '$2',
                            textAlign: 'left',
                        }}
                        endIcon={<SVG src={ChevronRight} />}
                        key={key}
                        onClick={onClick}
                        variant="plain"
                    >
                        {text}
                    </Button>
                ))}
            </Grid>
        </StyledLeksikonCategory>
    )
}

export default LeksikonCategory

export { StyledLeksikonCategory }
